import json from '../routes.json'

export function getTranslatedRoutes() {
  const data = typeof json === 'string' ? JSON.parse(json) : json;
  const result = {};

  for (const key in data.routes) {
    if (Object.prototype.hasOwnProperty.call(data.routes, key)) {
      const tokens = data.routes[key].tokens.slice().reverse();
      let path = '';
      const name = key.split('.')[0];
      const lang = key.split('.')[1];

      tokens.forEach((token) => {
        if (token[0] === 'text' && token[1] !== '/') {
          path += token[1];
        }

        if (token[0] === 'variable') {
          path += `${token[1]}[${token[3]}]`;
        }
      })

      if (result[name] === undefined) {
        result[name] = {};
      }

      result[name][lang] = path
    }
  }

  return result;
}
